import { render, staticRenderFns } from "./cruceros.vue?vue&type=template&id=61060cbd&scoped=true&"
import script from "./cruceros.vue?vue&type=script&lang=js&"
export * from "./cruceros.vue?vue&type=script&lang=js&"
import style0 from "./cruceros.vue?vue&type=style&index=0&id=61060cbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61060cbd",
  null
  
)

export default component.exports